export { default as emphasizeAndEscapeText } from './emphasize-text';
